module.exports = __webpack_public_path__ + "static/media/stop-icon.2323df16.jpg";